import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import { TicketStatus } from '../../../../models/tickets';
import TicketRemainingTicketsCount from '../../TicketRemainingTicketsCount/TicketRemainingTicketsCount';
import TicketStepperSelector from '../../TicketStepperSelector';
import './MultiTicketCard.scss';

export interface MultiTicketCardProps {
    className?: string;
    displayPrice: string;
    isDisabled: boolean;
    name: string;
    onQuantityChange: (quantity: number) => void;
    quantityRemaining: number | null;
    selectedQuantity: number;
    statusKey: TicketStatus;
    ticketOptionsRange: number[];
    variantId: string;
}

export const MultiTicketCard: FunctionComponent<MultiTicketCardProps> = ({
    children,
    className,
    displayPrice,
    isDisabled,
    name,
    onQuantityChange,
    quantityRemaining,
    selectedQuantity,
    statusKey,
    ticketOptionsRange,
    variantId,
}) => {
    return (
        <article
            className={classnames('multi-ticket-card', className)}
            data-testid="multi-ticket-card"
        >
            <header className="multi-ticket-card-header">
                <h1 title={name} className="multi-ticket-card-header-title">
                    {name}
                </h1>
                <TicketStepperSelector
                    isCollapsedWhenMinimum={true}
                    isDisabled={isDisabled}
                    onQuantityChange={onQuantityChange}
                    selectedQuantity={selectedQuantity}
                    shouldAnimate={true}
                    ticketOptionsRange={ticketOptionsRange}
                    variantId={variantId}
                />
            </header>

            {children}

            <footer className="multi-ticket-card-footer">
                <span className="multi-ticket-card-footer-cost">
                    {displayPrice}
                </span>
                <span>
                    <TicketRemainingTicketsCount
                        numTicketsRemaining={quantityRemaining}
                        statusKey={statusKey}
                    />
                </span>
            </footer>
        </article>
    );
};

export default MultiTicketCard;
